import React from "react";

export const PopupableContext = React.createContext([]);

const UnnamedComponent = (props) => {
  const [shownModal, setShownModal] = React.useState();
  const [animating, setAnimating] = React.useState(false);

  const handleEscapeClick = React.useCallback((evt) => {
    if (evt.key === "Escape") {
      closeModal();
    }
  }, []);
  const disableScroll = React.useCallback(() => {
    document.body.style.overflow = "hidden";
  }, []);
  const enableScroll = React.useCallback(() => {
    document.body.style.overflow = "unset";
  }, []);
  const openModal = React.useCallback(() => {
    setShownModal(true);
    disableScroll();
    document.addEventListener("keydown", handleEscapeClick);
  }, []);
  const closeModal = React.useCallback(() => {
    setShownModal(false);
    enableScroll();
    document.removeEventListener("keydown", handleEscapeClick);
  }, []);
  const stopPropagation = React.useCallback((e) => {
    e.stopPropagation();
  }, []);
  const handleClickOutsideModalEffect = React.useCallback((e) => {
    if (animating) return;
    setAnimating(true);
    const el = e.target.querySelector("div");
    // const width = el.clientWidth;
    // const height = el.clientHeight;
    const { paddingLeft, paddingRight, paddingTop, paddingBottom } =
      window.getComputedStyle(el);
    // const actualWidth =
    // width - parseFloat(paddingLeft) - parseFloat(paddingRight);
    // const actualHeight =
    // height - parseFloat(paddingTop) - parseFloat(paddingBottom);

    // el.style.width = `${actualWidth * 1.01}px`;
    // el.style.height = `${actualHeight * 1.01}px`;

    el.style.paddingLeft = `${parseFloat(paddingLeft) * 1.2}px`;
    el.style.paddingRight = `${parseFloat(paddingRight) * 1.2}px`;
    el.style.paddingTop = `${parseFloat(paddingTop) * 1.2}px`;
    el.style.paddingBottom = `${parseFloat(paddingBottom) * 1.2}px`;

    setTimeout(() => {
      // el.style.width = `${actualWidth}px`;
      // el.style.height = `${actualHeight}px`;

      el.style.paddingLeft = `${paddingLeft}`;
      el.style.paddingRight = `${paddingRight}`;
      el.style.paddingTop = `${paddingTop}`;
      el.style.paddingBottom = `${paddingBottom}`;
      setAnimating(false);
    }, 100);
  }, []);

  const contextValue = React.useMemo(
    () => ({
      openModal,
      shownModal,
      handleClickOutsideModalEffect,
      stopPropagation,
      closeModal,
    }),
    [
      openModal,
      shownModal,
      handleClickOutsideModalEffect,
      stopPropagation,
      closeModal,
    ],
  );
  return (
    <PopupableContext value={contextValue}>{props.children}</PopupableContext>
  );
};
export default UnnamedComponent;
